
import Vue from 'vue'
import { Estimate } from '@/model/estimate'
import { PriceTable } from '@/model/product'

export default Vue.extend({
  data() {
    return {
      isLoading: false
    }
  },
  computed: {
    priceTable(): PriceTable {
      return this.$store.getters.priceTable
    },
    estimate(): Estimate {
      return this.$store.getters.estimate
    }
  }
})
